export enum UnityType {
    Unity = 1,
    Kg = 2,
    Liter = 3,
    Meter = 4
}
